
import { defineComponent } from "vue";
import { formatLocalDate } from "@/lib/utility/common";
import { formatThounsandNumber, isNumber } from "@/lib/utility/stringUtil";

export default defineComponent({
  name: "ContractDetailReadonly",
  props: {
    contractPartnerName: { type: String },
    contractInformation: { type: Object },
    contractCustomFields: { type: Array },
  },
  setup(){
    return {
      isNumber,
      formatLocalDate,
      formatThounsandNumber,
    };
  },
});
